/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';

const sortType = [
    {
        value: 'ascending', label: 'Ascending',
    },
    {
        value: 'descending', label: 'Descending',
    },
];

function SortComp(props) {
    const { setIsOpen, isOpen, onSortChange, sortOptions = [], defaultSort = '', defaultSortType = 'ascending', hideSortType = false } = props;
    const [selectedSort, setSelectedSort] = useState(defaultSort);
    const [selectedSortType, setSelectedSortType] = useState(defaultSortType);
    const containerRef = useRef(null);

    useEffect(() => {
        if(defaultSort && defaultSortType) {
            const sortOption = sortOptions.find((option) => option.value === selectedSort);
            setSelectedSort(defaultSort);
            setSelectedSortType(defaultSortType);
            onSortChange(defaultSort, defaultSortType, sortOption?.type);
        }
    }, [defaultSort, defaultSortType, sortOptions]);

    const handleReset = () => {
        setSelectedSort(defaultSort);
        setSelectedSortType(defaultSortType);
    };

    const handleApply = () => {
        if (onSortChange) {
            const sortOption = sortOptions.find((option) => option.value === selectedSort);
            onSortChange(selectedSort, selectedSortType, sortOption?.type);
        }
        setIsOpen(false);
    };

    // Close when clicking outside or pressing Escape
    useEffect(() => {
        if (!isOpen) return undefined;
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside, { passive: true });
        document.addEventListener('keydown', handleEsc);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
            document.removeEventListener('keydown', handleEsc);
        };
    }, [isOpen, setIsOpen]);

    if (!isOpen) return null;

    return (
        <div ref={containerRef} className='absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg border border-gray-200 w-64 z-50'>
            <div className='flex items-center justify-between px-3 py-2 border-b border-gray-200'>
                <h2 className='text-sm font-semibold text-gray-900'>Sort By</h2>
                <button
                    onClick={() => setIsOpen(false)}
                    className='p-1 hover:bg-gray-100 rounded-full transition-colors'
                >
                    <X size={16} className='text-gray-500' />
                </button>
            </div>

            <div className='px-3 py-2'>
                <div className='space-y-1'>
                    {sortOptions.map((option) => (
                        <label
                            key={option.value}
                            className='flex items-center cursor-pointer hover:bg-gray-50 px-2 py-1.5 rounded transition-colors'
                        >
                            <input
                                type='radio'
                                name='sortOption'
                                value={option.value}
                                checked={selectedSort === option.value}
                                onChange={(e) => setSelectedSort(e.target.value)}
                                className='w-3.5 h-3.5 text-yellow-500 border-gray-300'
                            />
                            <span className='ml-2 text-xs font-medium text-gray-700'>
                                {option.label}
                            </span>
                        </label>
                    ))}
                    {!hideSortType && (
                        <>
                            <div className='border-t border-gray-200 w-full ' />
                            {sortType.map((option) => (
                                <label
                                    key={option.value}
                                    className='flex items-center cursor-pointer hover:bg-gray-50 px-2 py-1.5 rounded transition-colors'
                                >
                                    <input
                                        type='radio'
                                        name='sortType'
                                        value={option.value}
                                        checked={selectedSortType === option.value}
                                        onChange={(e) => setSelectedSortType(e.target.value)}
                                        className='w-3.5 h-3.5 text-yellow-500 border-gray-300'
                                    />
                                    <span className='ml-2 text-xs font-medium text-gray-700'>
                                        {option.label}
                                    </span>
                                </label>
                            ))}
                        </>
                    )}

                </div>
            </div>

            <div className='flex gap-2 px-3 py-2 border-t border-gray-200'>
                <button
                    onClick={handleReset}
                    className='flex-1 px-3 py-1.5 text-xs font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded transition-colors'
                >
                    Reset
                </button>
                <button
                    onClick={handleApply}
                    className='flex-1 px-3 py-1.5 text-xs font-medium text-white bg-yellow-500 hover:bg-yellow-600 rounded transition-colors'
                >
                    Apply
                </button>
            </div>
        </div>
    );
}

export default SortComp;
